export enum SIZES {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}
